import $ from 'jquery';
import AdjusterShareSelector from './AdjusterShareSelector';
import {Fee} from './FeeSchedule';

class FeeTable {

  constructor(form) {
    this.form = form;
    this.feeSchedule = form.feeSchedule;
    this.$table = form.$form.find('#fee_schedule_fees');
    this.$tbody = this.$table.children('tbody');
    this.colCount = 8;
  }

  isEmpty() {
    return !this.feeSchedule.fees.length;
  }

  emptyRow() {
    this.$tbody.empty();

    var $tr = $('<tr/>').addClass('empty-fees').appendTo(this.$tbody);
    var $td = $('<td/>')
      .attr('colspan', this.colCount)
      .addClass('text-muted')
      .appendTo($tr);
    $td.text('This fee schedule has no fees');
  }

  buildRows() {
    this.$tbody.find('tr.empty-fees').remove();
    let _this = this;

    this.feeSchedule.fees.forEach(function(item, index, array) {
      let $tr = _this.buildRow(item);
      _this.$tbody.append($tr);
    });
  }

  insertRow(ix, fee) {
    let $trEmpty = this.$tbody.find('tr.empty-fees');
    if ($trEmpty.length) {
      this.buildRows();
    }
    else {
      $trEmpty.remove();
      let $tr = this.buildRow(fee);
      if (ix > 0) {
        this.$tbody.find('tr:eq(' + (ix-1) + ')').after($tr);
      }
      else {
        this.$tbody.append($tr);
      }
    }
  }

  buildRow(fee) {
    let $tr = $('<tr/>')
      .attr('data-uuid', fee.uuid)
      .data('item', fee);

    if (fee.is_new) {
      $tr.addClass('info');
    }

    let $td = $('<td/>').appendTo($tr);
    $('<input/>').attr('type', 'text')
      .addClass('form-control form-control-sm')
      .attr('name', 'other_fee_name[]')
      .attr('data-field', 'name')
      .val(fee.name)
      .appendTo($td);


    let $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'other_fee_uuid[]')
      .attr('data-field', 'uuid')
      .val(fee.uuid)
      .appendTo($td);

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'other_fee_type[]')
      .attr('data-field', 'type')
      .val(fee.type)
      .appendTo($td);

    $ig = $('<div/>').addClass('input-group input-group-sm')
      .appendTo($td);
    let addonDiv = $('<div/>').addClass('input-group-prepend')
      .appendTo($ig);
    $('<span/>').addClass('input-group-addon')
      .text('$')
      .appendTo(addonDiv);
    $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'other_fee_rate[]')
      .attr('data-field', 'rate')
      .val(fee.rate)
      .appendTo($ig);

    $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'other_fee_adjuster_rate[]')
      .attr('data-field', 'adjuster_rate')
      .attr('placeholder', 'blank if n/a')
      .val(fee.adjuster_rate)
      .appendTo($ig);

    let $bg = $('<div/>').addClass('input-group-append')
      .appendTo($ig);
    let $btn = $('<button/>').attr('type', 'button')
      .addClass('btn btn-default')
      .attr('data-action', 'select-fee-type')
      .attr('data-fee-type', 'fixed')
      .text('fixed')
      .appendTo($bg);
    if (fee.type === 'fixed') $btn.removeClass('btn-default').addClass('btn-primary active');
    $btn = $('<button/>').attr('type', 'button')
      .addClass('btn btn-default')
      .attr('data-action', 'select-fee-type')
      .attr('data-fee-type', 'per_unit')
      .text('per unit')
      .appendTo($bg);
    if (fee.type === 'per_unit') $btn.removeClass('btn-default').addClass('btn-primary active');

    $td = $('<td/>').addClass('text-center other-fee-included')
      .appendTo($tr);
    let $input = $('<input/>').attr('type', 'text').addClass('form-control form-control-sm')
      .attr('name', 'other_fee_included[]')
      .attr('data-field', 'included')
      .val(fee.included)
      .appendTo($td);
    let $blank = $('<p/>').addClass('form-control-plaintext')
      .text('-')
      .appendTo($td);

    if (fee.type === 'per_unit') {
      $blank.addClass('d-none');
    }
    else {
      $input.addClass('d-none');
    }

    $td = $('<td/>').appendTo($tr);
    let adjusterShareSelector = new AdjusterShareSelector(fee);
    adjusterShareSelector.attach($td);

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    let $ig = $('<div/>').addClass('checkbox m-b-none m-t-sm')
      .appendTo($td);
    let $label = $('<label/>').appendTo($ig);
    let $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-taxable', true)
      .appendTo($label);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'other_fee_taxable[]')
      .attr('data-field', 'taxable')
      .val(fee.taxable ? 1 : 0)
      .appendTo($td);
    $chk.prop('checked', fee.taxable);

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $ig = $('<div/>').addClass('checkbox m-b-none m-t-sm')
      .appendTo($td);
    $label = $('<label/>').appendTo($ig);
    $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-discountable', true)
      .appendTo($label);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'other_fee_discountable[]')
      .attr('data-field', 'discountable')
      .val(fee.discountable ? 1 : 0)
      .appendTo($td);
    $chk.prop('checked', fee.discountable);

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $ig = $('<div/>').addClass('checkbox m-b-none m-t-sm')
      .appendTo($td);
    $label = $('<label/>').appendTo($ig);
    $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-default', true)
      .appendTo($label);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'other_fee_default[]')
      .attr('data-field', 'default')
      .val(fee.default ? 1 : 0)
      .appendTo($td);
    $chk.prop('checked', fee.default);

    $td = $('<td/>').addClass('text-center').appendTo($tr);
    $ig = $('<div/>').addClass('checkbox m-b-none m-t-sm')
      .appendTo($td);
    $label = $('<label/>').appendTo($ig);
    $chk = $('<input/>').attr('type', 'checkbox')
      .attr('data-autobill', true)
      .appendTo($label);
    $hidden = $('<input/>').attr('type', 'hidden')
      .attr('name', 'other_fee_autobill[]')
      .attr('data-field', 'autobill')
      .val(fee.autobill ? 1 : 0)
      .appendTo($td);
    $chk.prop('checked', fee.autobill);

    $td = $('<td/>').addClass('text-center')
      .appendTo($tr);
    $btn = $('<button/>').attr('type', 'button')
      .addClass('btn').addClass('btn-danger')
      .attr('data-action', 'remove-fee')
      .appendTo($td);
    $('<i/>').addClass('fa fa-trash').appendTo($btn);

    return $tr;
  }

  init() {
    this.setupEvents();

    if (this.isEmpty()) {
      this.emptyRow();
    }
    else {
      this.buildRows();
    }

    this.setupFooter();
  }

  setupFooter() {

    let $td = this.$table.find('tfoot>tr>td.td-adjuster-share-selector');
    let adjusterShareSelector = new AdjusterShareSelector();
    adjusterShareSelector.attach($td);
    $td.data('adjuster-share-selector', adjusterShareSelector);
  }

  clearNewRow() {
    this.$table.find('#new_name').val('');
    this.$table.find('#new_rate').val('');
    this.$table.find('#new_adjuster_rate').val('');
    this.$table.find('#new_rate').closest('.input-group').find('.active[data-action=select-fee-type]').removeClass('active btn-primary').addClass('btn-default');
    this.$table.find('#new_rate').closest('.input-group').find('[data-fee-type="fixed"]').removeClass('btn-default').addClass('active btn-primary');
    this.$table.find('#new_included').val('');
    this.$table.find('#new_included').addClass('d-none');
    this.$table.find('#new_included').closest('td').find('.form-control-plaintext').removeClass('d-none');
    this.$table.find('#new_taxable,#new_discountable,#new_default').prop('checked', false);

    let $td = this.$table.find('tfoot>tr>td.td-adjuster-share-selector');
    let adjusterShareSelector = $td.data('adjuster-share-selector');
    adjusterShareSelector.reset();
  }

  addRow(btn) {
    let data = this.getNewFeeData();
    let fee = new Fee(data);
    let ix = this.feeSchedule.addFee(fee);
    this.insertRow(ix, fee);
    this.clearNewRow();
  }

  removeRow(btn) {
    let $tr = $(btn).closest('tr');
    let uuid = $tr.data('uuid');
    let $trNext = $tr.next('tr');

    $tr.remove();

    this.feeSchedule.removeFee(uuid);

    if (this.isEmpty()) {
      this.emptyRow();
    }
  }

  selectFeeType(btn) {
    let $btn = $(btn);
    let $tr = $btn.closest('tr');
    let uuid = $tr.data('uuid');
    let feeType = $btn.data('fee-type');
    let $activeBtn = $btn.closest('td').find('.active[data-action=select-fee-type]');
    let $feeTypeInput = $tr.find('input:hidden[name^="other_fee_type"]');

    $activeBtn.removeClass('active btn-primary').addClass('btn-default');
    $btn.removeClass('btn-default').addClass('btn-primary active');

    $feeTypeInput.val(feeType);

    let $included = $tr.find('.other-fee-included');

    if (feeType === 'per_unit') {
      $included.find('input').removeClass('d-none');
      $included.find('.form-control-plaintext').addClass('d-none');
    }
    else {
      $included.find('input').addClass('d-none');
      $included.find('.form-control-plaintext').removeClass('d-none');
    }
  }

  toggleCheckbox(chk) {
    let $chk = $(chk);
    let $hidden = $chk.closest('td').find('input:hidden');
    $hidden.val($chk.is(':checked') ? 1 : 0);
  }

  getNewFeeData() {
    let data = {};
    data.valid = true;
    data.is_new = true;
    data.name = this.$table.find('#new_name').val();
    data.rate = parseFloat(this.$table.find('#new_rate').val());
    data.adjuster_rate = parseFloat(this.$table.find('#new_adjuster_rate').val());
    data.type = this.$table.find('#new_rate').closest('.input-group').find('.active[data-action=select-fee-type]').data('fee-type');
    data.included = parseFloat(this.$table.find('#new_included').val());
    data.adjuster_payout = {};
    data.adjuster_payout.type = this.$table.find('#new_fee_adjuster_payout_type').val();
    data.adjuster_payout.rate = parseFloat(this.$table.find('#new_fee_adjuster_payout_rate').val());
    data.taxable = this.$table.find('#new_taxable').is(':checked');
    data.discountable = this.$table.find('#new_discountable').is(':checked');
    data.default = this.$table.find('#new_default').is(':checked');
    data.autobill = this.$table.find('#new_autobill').is(':checked');

    if (data.rate !== null && (isNaN(data.rate) || data.rate <= 0 )) {
      data.valid = false;
    }

    const raw_adjuster_rate = this.$table.find('#new_adjuster_rate').val();
    if ((raw_adjuster_rate !== '') && (isNaN(data.adjuster_rate) || data.adjuster_rate <= 0 )) {
      data.valid = false;
    }

    if (!data.name || !$.trim(data.name).length) {
      data.valid = false;
    }
    if (data.type !== 'fixed' && data.type !== 'per_unit') {
      data.valid = false;
    }
    if (data.type === 'per_unit' && !isNaN(data.included) && data.included < 0) {
      data.valid = false;
    }
    if (data.adjuster_payout.type === 'custom' && (
      isNaN(data.adjuster_payout.rate) ||
      (!isNaN(data.adjuster_payout.rate) && data.adjuster_payout.rate < 0))
    )
    {
      data.valid = false;
    }

    return data;
  }

  getRowData($tr) {
    let data = {};
    $tr.find('[data-field]').each(function(ix) {
      let $el = $(this);
      data[$el.data('field')] = $el.val();
    });
    return data;
  }

  validateNewRow() {
    let data = this.getNewFeeData();

    if (data.valid) {
      this.$table.find('button[data-action=add-fee]').prop('disabled', false);
    }
    else {
      this.$table.find('button[data-action=add-fee]').prop('disabled', true);
    }
  }

  highlightIfDirty($tr) {
    let fee = $tr.data('item');
    if (fee.is_new) return;

    let data = this.getRowData($tr);
    if (fee.isDirty(data)) {
      $tr.addClass('warning');
    }
    else {
      $tr.removeClass('warning');
    }
  }

  setupEvents() {
    let _this = this;

    this.$table.on('click', '[data-action=add-fee]', function(e) {
      _this.addRow(e.currentTarget);
    }).on('click', '[data-action=remove-fee]', function(e) {
      _this.removeRow(e.currentTarget);
    }).on('click', '[data-action=select-fee-type]', function(e) {
      _this.selectFeeType(e.currentTarget);
      _this.validateNewRow();
    }).on('click', 'input:checkbox[data-taxable],input:checkbox[data-discountable],input:checkbox[data-default],input:checkbox[data-autobill]', function(e) {
      _this.toggleCheckbox(e.currentTarget);
    }).on('keyup', 'tfoot input:text,tfoot input[type=text]', function(e) {
      _this.validateNewRow();
    }).on('click', 'tfoot .adjuster-share-selector a[data-type]', function(e) {
      _this.validateNewRow();
    }).on('click', 'tbody .adjuster-share-selector a[data-type], tbody input:checkbox, tbody [data-action=select-fee-type]', function(e) {
      _this.highlightIfDirty($(e.currentTarget).closest('tr'));
    }).on('keyup', 'tbody input[type=text], tbody input[type=text]', function(e) {
      _this.highlightIfDirty($(e.currentTarget).closest('tr'));
    });
  }
}

export default FeeTable;
